import React from "react";
import ReceivableStatics from "../../../../components/finance/ReportReceivable"

function Receivable() {
    return (
        <ReceivableStatics isTenant={true}/>
    )
}

export default Receivable